import { ProbabilityCategories } from '../../models/Probabilities';

let ProbabilityCalculator = {
  determineSuccessCategory: function(percentage: number) {
    if (percentage === 0.0) {
      return ProbabilityCategories.Fail;
    } else if (percentage > 0.0 && percentage < 0.25) {
      return ProbabilityCategories.Low;
    } else if (percentage >= 0.25 && percentage < 0.75) {
      return ProbabilityCategories.Uncertain;
    } else if (percentage >= 0.75 && percentage < 0.9) {
      return ProbabilityCategories.Likely;
    } else if (percentage >= 0.9 && percentage < 1.0) {
      return ProbabilityCategories.VeryLikely;
    } else {
      return ProbabilityCategories.Certain;
    };
  },
  
  determineProbabilityClassName: function(category: ProbabilityCategories) {
    if (category == ProbabilityCategories.Fail) {
      return 'probability-fail';
    } else if (category == ProbabilityCategories.Low) {
      return 'probability-low';
    } else if (category == ProbabilityCategories.Uncertain) {
      return 'probability-uncertain';
    } else if (category == ProbabilityCategories.Likely) {
      return 'probability-likely';
    } else if (category == ProbabilityCategories.VeryLikely) {
      return 'probability-verylikely';
    } else {
      return 'probability-certain';
    };
  }
};

export default ProbabilityCalculator;


// WEBPACK FOOTER //
// ./src/services/statistics/ProbabilityCalculator.ts